import React from "react";
import ReactPaginate from "react-paginate";
import Loading from "../../../components/loading";

export default function ListWorkItem({
    loading,
    filtered,
    selected,
    handleSelect,
    handleToggleStatus,
    pageCount,
    handlePageClick,
}) {
    return (
        <div className="table-responsive">
            <table className="table table-bordered">
                <thead>
                    <tr>

                        <th>Select</th>

                        <th>
                            Project Category
                        </th>

                        <th>
                            Work Item Code
                        </th>

                        <th>
                            Description
                        </th>

                        <th>
                            Work Activities
                        </th>

                        <th>
                            Status
                        </th>

                    </tr>

                </thead>
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan="4" className="text-center">
                                <Loading />
                            </td>
                        </tr>
                    ) : filtered.length > 0 ? (
                        filtered.map((item, index) => {

                            const isActive =
                                item.status === "Active";

                            return (

                                <tr key={item.id}>

                                    {/* SELECT */}

                                    <td>

                                        <input
                                            type="radio"
                                            name="select"
                                            checked={selected === item.id}
                                            onChange={() =>
                                                handleSelect(item.id)
                                            }
                                        />

                                    </td>

                                    {/* PROJECT CATEGORY */}

                                    <td>
                                        {item.projectCategoryName || "-"}
                                    </td>

                                    {/* WORK ITEM CODE */}

                                    <td>
                                        {item.workItemCode}
                                    </td>

                                    {/* DESCRIPTION */}

                                    <td>
                                        {item.workItemDescription || "-"}
                                    </td>

                                    {/* ACTIVITIES */}

                                    <td style={{ width: "300px" }}>

                                        <table className="table table-bordered table-sm mb-0">

                                            <thead className="table-dark">

                                                <tr>


                                                    <th>
                                                        Activity
                                                    </th>
                                                    <th>UOM</th>

                                                </tr>



                                            </thead>

                                            <tbody>

                                                {item.workActivities?.length > 0 ? (

                                                    item.workActivities.map((a, i) => (

                                                        <tr key={i}>


                                                            <td>
                                                                {a.workActivityName}
                                                            </td>
                                                            <td>
                                                                {a.uom || "-"}
                                                            </td>

                                                        </tr>

                                                    ))

                                                ) : (

                                                    <tr>

                                                        <td
                                                            colSpan="2"
                                                            className="text-center"
                                                        >
                                                            No Activities
                                                        </td>

                                                    </tr>

                                                )}

                                            </tbody>

                                        </table>

                                    </td>

                                    {/* STATUS */}

                                    <td>

                                        <span
                                            className={`badge ${isActive
                                                ? "bg-success"
                                                : "bg-secondary"
                                                }`}
                                            style={{ cursor: "pointer" }}
                                            onClick={() =>
                                                handleToggleStatus(item)
                                            }
                                        >
                                            {isActive
                                                ? "Active"
                                                : "Inactive"}
                                        </span>

                                    </td>

                                </tr>

                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4" className="text-center">
                                No records found
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>

            <ReactPaginate
                breakLabel="..."
                nextLabel="Next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
                containerClassName="pagination-container"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
            />
        </div>
    );
}
